export var AS_BUTTON = 'Button';